import { MAX_NOTIFICATIONS_COUNT } from '../../fr-page-layout/constants';

export const getNavigationNotificationsStyle = (
    notificationCount: number
): Omit<React.CSSProperties, 'color' | 'backgroundColor'> => ({
    position: 'absolute',
    right: notificationCount > MAX_NOTIFICATIONS_COUNT ? '25%' : '30%',
    top: '5px',
});
